const KEY = "gospot_city";

export function getCity() {
  return localStorage.getItem(KEY) || "Québec, QC";
}

export function setCity(label) {
  localStorage.setItem(KEY, label);
  window.dispatchEvent(new Event("gospot:citychange"));
}
